/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Button } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const getStyles = () => ({
  sdkSettingsActionBar: {
    padding: '12px 38px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  cancelBtn: {
    '&.fui-Button': {
      marginRight: 8,
    },
  },
});

interface ISDKSettingsActionBar {
  onCancel: () => void;
  onSubmit: () => void;
}

export const SDKSettingsActionBar: React.FC<ISDKSettingsActionBar> = React.memo(({
  onCancel,
  onSubmit,
}) => {
  const classes = useDefaultStyles(getStyles);
  const i18n = useContext(I18nContext) as any;

  return (
    <div className={classnames(classes.sdkSettingsActionBar, 'sdk-settings-action-bar')} >
      <Button onClick={onCancel} className={classnames(classes.cancelBtn, 'cancel-button')}>{i18n.getString(_TL_('Cancel'))}</Button>
      <Button onClick={onSubmit} appearance="primary" className="save-button">{i18n.getString(_TL_('Save'))}</Button>
    </div>
  );
});
